import React from 'react';
import useBatchAgreements from './hooks/useBatchAgreements';
import BatchAgreements from './BatchAgreements';

const Container: React.FC = () => {
  const data = useBatchAgreements();

  if (!data) return null;

  return (
    <BatchAgreements
      batchAgreements={data.batchAgreements}
      availablePremiumAccessAgreements={data.availablePremiumAccessAgreements}
      userHasMultiplePaAgreements={data.userHasMultiplePaAgreements}
      showPaPicker={data.showPaPicker}
      currentPaAgreementId={data.currentPaAgreementId}
      isSwitchingPremiumAccessAgreement={data.isSwitchingPremiumAccessAgreement}
      switchingToPremiumAccessId={data.switchingToPremiumAccessId}
      switchPremiumAccessAgreementError={data.switchPremiumAccessAgreementError}
      onSelectPaAgreement={data.onSelectPaAgreement}
      isSingleAgreement={data.isSingleAgreement}
      canEditAgreementSelection={data.canEditAgreementSelection}
      multiPaBulkDownloadActive={data.multiPaBulkDownloadActive}
    />
  );
};

export default Container;
